import React from 'react';
import { type Route } from 'wouter';

import { decodeParams } from '../../utils/routes';
import { ParamsTransformer } from './ParamsTransformer';

export const DecodedParamsRoute: typeof Route = (props) => (
  <ParamsTransformer {...props} transformer={decodeParams} />
);
